import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { GlobalDesignActionLobbyItem } from '../types';
import { useGroupsPreviewPS } from '../common/lobby/useGroupsPreviewPS';
import { compose } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/common/composer';
import { GD_WDS_EXPERIMENT } from '../experiments';
import { LobbyItemLayout } from '../common/lobby/LobbyItemLayout';
import { processStyleMetadataForLobby } from '../common/lobby/processStyleMetadataForLobby';
import { TEXT_PROPERTY_CONFIG } from './utils/textUtils';
import { useTextLobbyData } from './hooks/useTextLobbyData';
import { TextPreview } from '../controls/GroupPreview';

const TextLobbyItem: GlobalDesignActionLobbyItem = (props) => {
  const { experiments } = useExperiments({ readOnly: true });
  const isWDS = experiments.enabled(GD_WDS_EXPERIMENT);

  // Always call all hooks (React rules)
  const renderGroupPreviewPS = useGroupsPreviewPS(
    props.actionName,
    props.group,
  );
  const lobbyData = useTextLobbyData(props.group);

  if (!isWDS) {
    const processedStyleMetadata = processStyleMetadataForLobby(
      props.group.engine,
      TEXT_PROPERTY_CONFIG,
    );

    const font = compose('font', {
      fontSize: processedStyleMetadata.fontSize[0],
      fontFamily: processedStyleMetadata.fontFamily[0],
    });

    const value = {
      color: processedStyleMetadata.color[0] || '',
      font,
    };

    return (
      renderGroupPreviewPS({
        value,
        isMixedFontColor: processedStyleMetadata.isMixedFontColor,
        isMixedFontFamily: processedStyleMetadata.isMixedFontFamily,
        isMixedFontSize: processedStyleMetadata.isMixedFontSize,
        emptyPreviewLabel: lobbyData.emptyPreviewLabel,
        onClick: props.onSelect,
      }) ?? null
    );
  }

  return (
    <LobbyItemLayout
      actionName={props.actionName}
      group={props.group}
      onSelect={props.onSelect}
    >
      <TextPreview {...lobbyData} />
    </LobbyItemLayout>
  );
};

export default TextLobbyItem;
